import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dropdown } from './Dropdown';
import classNames from 'classnames';
/**
 * @export
 * A component that displays a popover with a title and content when clicking on its child element.
 * Uses the Dropdown component internally for positioning and click handling.
 *
 * @example Basic popover
 * ```tsx
 * <Popover
 *   title="User Info"
 *   content="John Doe - Software Engineer"
 * >
 *   <button>View Details</button>
 * </Popover>
 * ```
 *
 * @example Custom position
 * ```tsx
 * <Popover
 *   title="Help"
 *   content="This is helpful information"
 *   position="right"
 * >
 *   <span>?</span>
 * </Popover>
 * ```
 *
 * @example JSX content
 * ```tsx
 * <Popover
 *   title={() => <strong>Important</strong>}
 *   content={() => (
 *     <div>
 *       <p>Line 1</p>
 *       <p>Line 2</p>
 *     </div>
 *   )}
 * >
 *   <button>Show Info</button>
 * </Popover>
 * ```
 *
 * @category Overlays
 */
const Popover = ({ title, content, position = 'bottom', showArrow = true, children }) => {
    const popoverContent = (_jsxs("div", { className: "uxpcore_popover__content", children: [_jsx("div", { className: "uxpcore_popover__title", children: typeof title === "string" ? title : title() }), _jsx("div", { className: "uxpcore_popover__body", children: typeof content === "string" ? content : content() })] }));
    return (_jsx(Dropdown, { trigger: children, content: popoverContent, position: position, contentClassName: classNames("uxpcore_popover", { 'uxpcore_popover--arrow': showArrow }), showAnchor: showArrow }));
};
export default Popover;
